import { useInfiniteQuery } from "@tanstack/react-query";

import { GetNotificationsByUser } from "@/api/graphql/notifications/types.ts";
import { getNotificationsByUser } from "@/api/graphql/notifications/user/api.ts";
import { createGetNotificationsByUserQueryOptions } from "@/api/graphql/notifications/user/queryOptions.ts";

export const useGetNotificationsByUser = ({
  pageSize,
  userId,
}: GetNotificationsByUser) => {
  const response = useInfiniteQuery(
    createGetNotificationsByUserQueryOptions(
      { pageSize, userId },
      getNotificationsByUser,
    ),
  );

  return {
    ...response,
    totalNotifications: response.data?.pages[0]?.pagination.total || 0,
  };
};
